import { createSelector } from '@reduxjs/toolkit'
import { AppState } from 'redux/rootReducer'
/**
 * Direct selector to the map state domain
 */

const selectMapDomain = (state: AppState) => state.map

/**
 * Other specific selectors
 */

export const makeSelectSearchCircle = createSelector(
  selectMapDomain,
  (substate) => substate.searchCircle
)

export const makeSelectPrincipalBounds = createSelector(
  selectMapDomain,
  (substate) => substate.principalBounds
)

export const makeSelectZoom = createSelector(
  selectMapDomain,
  (substate) => substate.zoom
)

export const makeSelectIsStreetViewOpen = createSelector(
  selectMapDomain,
  (substate) => substate.isStreetViewOpen
)

/**
 * Default selector
 */

const selectMap = createSelector(selectMapDomain, (substate) => substate)

export default selectMap
